export const MAX_RETRIES = 3;
export const SKIP_RETRIES_HTTP_STATUS = [401, 403, 500];
export const QUERY_CACHE_STALE_TIME = 1000 * 60 * 1;
